import { render, staticRenderFns } from "./gameComponnent.vue?vue&type=template&id=28abe72a&scoped=true&"
import script from "./gameComponnent.vue?vue&type=script&lang=js&"
export * from "./gameComponnent.vue?vue&type=script&lang=js&"
import style0 from "./gameComponnent.vue?vue&type=style&index=0&id=28abe72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28abe72a",
  null
  
)

export default component.exports